import { FormProvider } from "@/pages/forms/types/form";

// One place naming the providers, so the wizard, the list and the details page
// stop each carrying their own `provider === "TYPEFORM" ? … : …` literal.
export const PROVIDER_LABEL: Record<FormProvider, string> = {
  TYPEFORM: "Typeform",
  ROCKET_FORM: "Rocket Form",
};

// Short form for the badges in the list and details header.
export const PROVIDER_BADGE: Record<FormProvider, string> = {
  TYPEFORM: "Typeform",
  ROCKET_FORM: "Rocket",
};

export const PROVIDERS: FormProvider[] = ["TYPEFORM", "ROCKET_FORM"];
